import { createStore as reduxCreateStore } from "redux";

const ACTION_SET_HEADER_CLASS = "SET_HEADER_CLASS";
const ACTION_ADD_DEPT = "ADD_DEPT";
const ACTION_SET_DEPTS = "SET_DEPTS";
const ACTION_REMOVE_DEPT = "REMOVE_DEPT";
const ACTION_SET_JOB_ID = "SET_JOB_ID";
const ACTION_SET_JOB_TEAM = "SET_JOB_TEAM";
const ACTION_SET_JOB_SLUG = "SET_JOB_SLUG";
const ACTION_SET_JOB_TITLE = "SET_JOB_TITLE";

const initialState = {
  selectedDepartments: [],
  headerClass: "",
  jobId: "",
  jobTeam: "",
  jobSlug: "",
  jobTitle: ""
};

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_SET_HEADER_CLASS:
      return Object.assign({}, state, {
        headerClass: action.value
      });
    case ACTION_ADD_DEPT:
      let newState = state.selectedDepartments.slice();

      newState.push(action.value);

      return Object.assign({}, state, {
        selectedDepartments: newState
      });
    case ACTION_SET_DEPTS:
      let newDepartments = action.value;

      return Object.assign({}, state, {
        selectedDepartments: newDepartments
      });
    case ACTION_SET_JOB_ID:
      return Object.assign({}, state, {
        jobId: action.value
      });
    case ACTION_SET_JOB_SLUG:
      return Object.assign({}, state, {
        jobSlug: action.value
      });
    case ACTION_SET_JOB_TITLE:
      return Object.assign({}, state, {
        jobTitle: action.value
      });
    case ACTION_SET_JOB_TEAM:
      return Object.assign({}, state, {
        jobTeam: action.value
      });
    case ACTION_REMOVE_DEPT:
      let previousState = state.selectedDepartments.slice();

      return Object.assign({}, state, {
        selectedDepartments: previousState.filter(item => item !== action.value)
      });
    default:
      return state;
  }
};

const createStore = () => {
  return reduxCreateStore(reducer, initialState);
};

const mapStateToProps = ({
  selectedDepartments,
  headerClass,
  jobId,
  jobTeam,
  jobSlug,
  jobTitle
}) => {
  return {
    selectedDepartments,
    headerClass,
    jobId,
    jobTeam,
    jobSlug,
    jobTitle
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setSelectedDepartments: depts => {
      return dispatch({
        type: ACTION_SET_DEPTS,
        value: depts
      });
    },
    setJobId: id => {
      return dispatch({
        type: ACTION_SET_JOB_ID,
        value: id
      });
    },
    setJobTeam: team => {
      return dispatch({
        type: ACTION_SET_JOB_TEAM,
        value: team
      });
    },
    setJobSlug: slug => {
      return dispatch({
        type: ACTION_SET_JOB_SLUG,
        value: slug
      });
    },
    setJobTitle: title => {
      return dispatch({
        type: ACTION_SET_JOB_TITLE,
        value: title
      });
    },
    addSelectedDepartment: id => {
      return dispatch({
        type: ACTION_ADD_DEPT,
        value: id
      });
    },
    removeSelectedDepartment: id => {
      return dispatch({
        type: ACTION_REMOVE_DEPT,
        value: id
      });
    },
    setHeaderClass: newClass => {
      return dispatch({
        type: ACTION_SET_HEADER_CLASS,
        value: newClass
      });
    }
  };
};

export { createStore, mapStateToProps, mapDispatchToProps };
